'use strict';

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.find/~/es-abstract/helpers/isPrimitive.js
// module id = 2708
// module chunks = 0